'use client'

// @ts-strict-ignore
import clsx from 'clsx'
import { memo } from 'react'

import { useOpenAccessoriesOffer } from '@/features/cart/accessories-offer'
import { CreatePreorder } from '@/features/order/create-preorder'

import { TProduct } from '@/shared/types/product-types'

import { YandexBadgesClient } from '../YandexBadges/YandexBadges.client'

import cl from './BottomControllerReservation.module.scss'

interface BottomControllerReservationProps {
	productData: TProduct
	type: 'regular' | 'wide' | 'wideOnMobile'
	price: number
	buttonName?: string
	hideBadge?: boolean
}

export const BottomControllerReservation = memo((props: BottomControllerReservationProps) => {
	const { productData, type, price, buttonName, hideBadge } = props
	const { loadingAction, openOrderWithAccessories } = useOpenAccessoriesOffer()

	const onReservationClick = async () => {
		await openOrderWithAccessories({
			action: 'preorder',
			productCode: productData.KOD,
			productId: productData.ID,
			productPreview: { TITLE: productData.TITLE, IMAGE: productData.IMAGE || productData.IMAGES?.[0] }
		})
	}

	return (
		<>
			{hideBadge ? <YandexBadgesClient price={price} cardType={type} /> : <>&nbsp;</>}
			<div className={clsx(cl.root, cl[type])}>
				<CreatePreorder
					className={cl.button}
					buttonName={buttonName}
					onClick={onReservationClick}
					isLoading={loadingAction === 'preorder'}
				/>
			</div>
		</>
	)
})
